module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "c-card--claim-forms__body"
  }, [(_vm.submitError) ? _c('div', {
    staticClass: "c-validation t-alert-danger u-margin-bottom-10"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('web.card_claims_submitter.submit_error')))])]) : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('h3', {
    staticClass: "u-h1 u-no-top-margin"
  }, [_vm._v(_vm._s(_vm.forms[_vm.formIndex].name))]), _vm._v(" "), (_vm.forms[_vm.formIndex].description) ? _c('p', [_vm._v(_vm._s(_vm.forms[_vm.formIndex].description))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.forms[_vm.formIndex].fields), function(field) {
    return _c('fieldset', {
      staticClass: "o-fieldset c-card--claim-forms__fieldset"
    }, [_c(_vm.getFieldComponentType(field), {
      tag: "component",
      attrs: {
        "field": field,
        "errors": _vm.errors,
        "template": 'edit'
      },
      model: {
        value: (_vm.model[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.model, field.name, $$v)
        },
        expression: "model[field.name]"
      }
    }), _vm._v(" "), _vm._l((_vm.errors[field.name]), function(error) {
      return _c('div', [_c('div', {
        staticClass: "c-validation t-alert-danger"
      }, [_vm._v(_vm._s(error))])])
    })], 2)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "c-card--claim-forms__footer"
  }, [_c('button', {
    ref: "cancelButton",
    staticClass: "c-button t-button-plain qa-cancel",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('web.form_detail.cancel_button')) + "\n    ")]), _vm._v(" "), _c('button', {
    ref: "submitButton",
    staticClass: "c-button\n                   c-card--claim-forms__footer__button\n                   t-button-primary\n                   qa-submit-this-claim",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('web.form_detail.submit_button')) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-117debee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/forms/FormDetail.vue
// module id = 510
// module chunks = 1